import { z } from 'my-zod'
import { workOrderModel } from './work-order-model'

export const updateWorkOrderRequest = workOrderModel
  .omit({
    shortId: true
  })
  .augment({
    reduceInventory: z.boolean().optional()
  })

export type updateWorkOrderRequest = z.infer<typeof updateWorkOrderRequest>
